(ns ycweb.app.pos.dev
  (:require
   #?(:clj [clojure.math.numeric-tower :refer [expt floor round]])
   #?(:cljs [goog.string :as gstring])
   [ycweb.components.buttons :as buttons]
   [ycweb.components.forms :as forms]
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.versioncheck :as versioncheck]
   [ycweb.components.history :as history]))

(defonce dev-state
  (atom
    (merge
      (u/read-edn-string (u/get-local-storage :dev/barcodes))
      {:open false :opening false})))



;; Thanks https://github.com/trhura/clojure-humanize/blob/master/src/clojure/contrib/humanize.cljc
#?(:clj (def num-format format)
   :cljs (def num-format #(gstring/format %1 %2)))

#?(:cljs (def floor (.-floor js/Math)))
#?(:cljs (def round (.-round js/Math)))
#?(:cljs (def expt (.-pow js/Math)))
#?(:clj (def log #(java.lang.Math/log %))
   :cljs (def log (.-log js/Math)))


(defn logn [num base]
  (/ (round (log num))
    (round (log base))))


(defn filesize
  "Format a number of bytes as a human readable filesize (eg. 10 kB). By
   default, decimal suffixes (kB, MB) are used.  Passing :binary true will use
   binary suffixes (KiB, MiB) instead."
  [bytes & {:keys [binary format]
            :or {binary false
                 format "%.1f"}}]

  (if (zero? bytes)
    ;; special case for zero
    "0"

    (let [decimal-sizes [:B, :KB, :MB, :GB, :TB,
                         :PB, :EB, :ZB, :YB]
          binary-sizes [:B, :KiB, :MiB, :GiB, :TiB,
                        :PiB, :EiB, :ZiB, :YiB]

          units (if binary binary-sizes decimal-sizes)
          base (if binary 1024 1000)

          base-pow (int (floor (logn bytes base)))
          ;; if base power shouldn't be larger than biggest unit
          base-pow (if (< base-pow (count units))
                     base-pow
                     (dec (count units)))
          suffix (name (get units base-pow))
          value (float (/ bytes (expt base base-pow)))]

      (str (num-format format value) suffix))))




;; Need a separate modal system to not interfere with global state..

(defn open-modal [{:keys [body footer key type] :as options}]
  (swap! dev-state merge (assoc options :opening true :open true)))

(defn close-modal []
  (let [modal-uuid (u/rand-uuid)
        {:keys [open opening]} @dev-state
        open? (or open opening)]

    (when open?
      (swap! dev-state assoc :open false :opening false :uuid modal-uuid)

      #?(:cljs
         (.setTimeout js/window
           #(if (= modal-uuid (:uuid @dev-state))
              (reset! dev-state
                (merge
                  (u/read-edn-string (u/get-local-storage :dev/barcodes))
                  {:open false :opening false})))
           200)))

    ;; Return whether the modal was actually needing to be closed
    open?))

(rum/defc history-indicator < rum/reactive [app-atom]
  (let [snapshot (rum/react history/app-snapshot)
        {:keys [index]} (rum/react history/app-snapshot)
        diffcount (count (:diffs snapshot))]
    [:div
     {:style
      {:width "100%"
       :position "fixed"
       :top "0px"
       :left "0px"
       :text-align "center"
       :font-size "8pt"
       :z-index "999"
       :color (if (not= index diffcount) "red" "white")}}
     (apply str
       (concat
         (repeat (/ (dec index) 20) "<")
         [(str " " index " ")]
         (repeat (/ (- diffcount index) 20) ">")))]))

(rum/defc modal < rum/reactive
  [app-atom]
  (let [{:keys [body footer open type]} (rum/react dev-state)
        body-val (cmn/curval body)
        footer-val (cmn/curval footer)]

    [:div
     {:class
      (u/bem :modal
        [(when footer-val :has-footer)
         (when open :is-open)
         type])}

     (when-not (versioncheck/dev-enabled app-atom)
       (history-indicator app-atom))
     [:div.modal__content
      body-val]
     (when footer-val
       [:div.modal__footer footer-val])
     [:a.modal__close-button
      {:on-click #(close-modal)}
      [:i {:class (u/bem :icon [:4-1 :close :block])}]]]))

(rum/defc modal-background < rum/reactive
  []
  (let [{:keys [opening]} (rum/react dev-state)]
    [:div
     {:class (u/bem :modal-overlay [(when opening :is-open)])}]))

(defn menu-modal
  [items]
  {:body
   (into
     [:ul.context-menu-list]
     (map
       (fn [i]
         [:li.context-menu-list__item
          (buttons/button (:label i)
            (fn []
              (when-not (:swap-modal i) (close-modal))
              (when (:on-click i) ((:on-click i))))

            (or (:style i)
              {:full true :large true :secondary true}))])
       items))
   :type :context-menu})

;; End of modal stuff..

(defn state->str [app-snapshot]
  (pr-str @app-snapshot))

(defn str->state [app-snapshot s]
  (reset! app-snapshot (u/read-edn-string s)))

(defn save-state []
  (u/set-local-storage :dev-state
    (state->str history/app-snapshot)))

(defn restore-state [app-atom]
  (str->state history/app-snapshot
    (u/get-local-storage :dev-state))

  (history/reset-to-end history/app-snapshot app-atom))

(defn load-serialized-state [app-atom]
  (str->state history/app-snapshot (get @dev-state :state-val))
  (println "Restoring history, disabling history reporting.")
  ;; Disable history sending when restoring state
  (swap! history/app-snapshot
    (fn [s]
      (->
        s
        (assoc-in [:comms-send-disabled] true)
        (assoc-in [:history-recording-disabled] true)

        ;; Set to bogus values, because we simply don't care about recording history at this point
        (assoc-in [:comms-index] 99999999999)
        (assoc-in [:comms-snapshot] {})
        (assoc-in [:snapshot :opts :send-history] false)
        (assoc :restoring true))))

  (history/history-restore-current app-atom @history/app-snapshot)
  (swap! history/app-snapshot assoc :restoring false)
  (close-modal))

(defn serialize-state [app-atom]
  (swap! dev-state assoc :state-val (state->str history/app-snapshot))
  {:body
   [:div.section
    (forms/textarea "Update state below:" (rum/cursor dev-state :state-val) {:rows 15})]
   :footer
   (grid/button-row
     {:left-fn #(close-modal)
      :left-no-icon true
      :right-text "Load"
      :right-no-icon true
      :right-fn
      #(load-serialized-state app-atom)})
   :type :alert})

(defn select-barcode [bk]
  (swap! dev-state assoc :selected bk))

(defn save-barcode [k]
  (u/set-local-storage :dev/barcodes (pr-str (select-keys @dev-state [:barcode1 :barcode2 :barcode3])))
  #_(comms/send :dev/barcodes
      (select-keys @dev-state [:barcode1 :barcode2 :barcode3])))

(defn dev-menu [app-atom]
  {:body
   (into
     [:ul.context-menu-list]
     (concat
       [[:li.context-menu-list__item
         (forms/input "" "Saved Barcode 1" (rum/cursor dev-state :barcode1)
           {:on-dark true :on-focus #(select-barcode :barcode1)
            :change-fn (partial save-barcode :barcode1)})]
        [:li.context-menu-list__item
         (forms/input "" "Saved Barcode 2" (rum/cursor dev-state :barcode2)
           {:on-dark true :on-focus #(select-barcode :barcode2)
            :change-fn (partial save-barcode :barcode2)})]
        [:li.context-menu-list__item
         (forms/input "" "Saved Barcode 3" (rum/cursor dev-state :barcode3)
           {:on-dark true :on-focus #(select-barcode :barcode3)
            :change-fn (partial save-barcode :barcode3)})]]
       (map
         (fn [i]
           [:li.context-menu-list__item
            (buttons/button (:label i)
              (fn []
                (when-not (:swap-modal i) (close-modal))
                (when (:on-click i) ((:on-click i))))

              (or (:style i)
                {:full true :large true :secondary true}))])
         [{:label "Save state"
           :on-click #(save-state)}
          {:label "Restore state"
           :on-click #(restore-state app-atom)}
          {:label "Serialize state"
           :swap-modal true
           :on-click #(open-modal (serialize-state app-atom))}
          {:label "Clear history"
           :on-click #(history/clear-history history/app-snapshot app-atom)}])
       [[:li.context-menu-list__item
         (forms/input "Barcode:" "" (rum/cursor dev-state :barcode)
           {:auto-focus (not (:disable-auto-focus @app-atom)) :on-dark true
            :on-focus #(select-barcode :barcode)})]]))
   :type :context-menu})

(defn dispatch-enter [scan-fn]
  (let [{:keys [barcode selected] :as dev} @dev-state
        barcode (or (get dev selected) barcode)]
    (when (u/presence barcode)
      (close-modal)
      (scan-fn barcode))))



(rum/defc dev-modals [app-atom]
  [:div
   #_(when (versioncheck/dev-enabled app-atom) (history-indicator app-atom))
   (modal-background)
   (modal app-atom)])


